var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"roma-bottom-nav d-block d-sm-none"},[_c('v-row',{attrs:{"no-gutters":""}},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }